// extracted by mini-css-extract-plugin
module.exports = {"menu":"SlideOutPanel_menu__1v7LX","title":"SlideOutPanel_title__qmCDV","button":"SlideOutPanel_button__3_8iG"};